import { NgModule } from "@angular/core";
import {FraudReportsTableComponent} from "./fraud-reports-table.component";
import {FraudReportModalComponent} from "./fraud-reports-modal";
import { AdminCommonModule } from "../admin-common.module";

import {ModalModule} from 'angular2-modal';
import {BootstrapModalModule} from 'angular2-modal/plugins/bootstrap';

@NgModule({
    declarations: [
        FraudReportsTableComponent,
        FraudReportModalComponent

    ],
    imports: [
        AdminCommonModule,
        ModalModule.forRoot(),
        BootstrapModalModule
    ],
    exports :[FraudReportsTableComponent, FraudReportModalComponent]
    
})
export class FraudReportsSiteModule {
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/fraud-reports/fraud-reports.module.ts